import React, { useEffect, useRef } from 'react'
import { Helmet } from 'react-helmet'
import { Route, Switch, useLocation } from 'react-router-dom'
import routes from './routes'
import favicon from 'ASSETS/png/favicon.png'
import { createGlobalStyle } from 'styled-components'
import { Message } from '@arco-design/web-react'
import { getTea, reportTea } from 'UTILS/tea'
import moment from 'moment'
import { getSlardar } from 'UTILS/slardar'

const GlobalStyle = createGlobalStyle`
  img.hiddenImg{
    position:fixed;
    opacity:0 !important;
    right:0;
    bottom:0;
  }
  img {
    opacity: 0;
  }
  img[src]  {
    opacity: 1;
  }
  .uploadModal{
    width:364px;
    height:96px;
    padding:24px;
    .arco-modal-header{
      margin:0;
    }
    .arco-modal-footer {
      position: absolute;
      right: 24px;
      bottom: 24px;
      text-align:right;
    }
  }
  .confirmModal{
    width:348px;
    height:134px;
    padding:24px 32px;
    .arco-modal-header {
      margin-bottom:20px;
    }
    .arco-modal-header .arco-modal-title {
      text-align:left;
    }
    .arco-modal-content {
      padding-left:28px;
    }
    .arco-modal-footer {
      position: absolute;
      right: 24px;
      bottom: 24px;
      text-align:right;
    }
  }
  body {
    font-family: PingFang SC, sans-serif !important;
  }
  .arco-select .arco-select-view{
    color: #282F38;
  }
  .arco-select-disabled .arco-select-view {
    color: #C2C6CC;
  }
`
Message.config({ maxCount: 1 })

function usePageOut() {
  const location = useLocation()
  const time = useRef(moment())
  useEffect(() => {
    const handleVisibillityChange = () => {
      if (document.hidden) {
        const maxTime = moment.min(time.current.clone().add(30, 'minutes'), moment())
        reportTea('page_out', {
          page_start_time: time.current.format('kk:mm:ss Z'),
          page_duration: moment(maxTime.diff(time.current)).format('mm:ss'),
          page_leave_url: location.pathname,
        })
      } else {
        time.current = moment()
      }
    }
    window.addEventListener('visibilitychange', handleVisibillityChange)
    return () => {
      window.removeEventListener('visibilitychange', handleVisibillityChange)
    }
  }, [])
}

const App = () => {
  usePageOut()
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line prettier/prettier
      (window as any).jobs = {}
    }
  }, [])
  return (
    <>
      <Helmet defaultTitle="veImageX体验版">
        <html translate="no" />
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, maximum-scale=1, minimum-scale=1"
        />
        <noscript>You need to enable JavaScript to run this app.</noscript>
        <link rel="icon" type="image/png" href={favicon} />
      </Helmet>
      <GlobalStyle></GlobalStyle>
      {getTea()}
      {getSlardar()}
      <Switch>
        {routes.map((route, index) => (
          <Route
            key={index}
            exact={route.exact}
            path={route.path}
            component={route.component}
          />
        ))}
      </Switch>
    </>
  )
}

export default App
